import React from 'react';
import styled from 'styled-components';

import { useTranslation, Trans } from '@lt/localization';

import { Link, Bubble } from '@lt/components';
import QuestionIcon from '@lt/components/icons-react/rebrand/QuestionOutline';

import {
  EXTRA_INSURANCE_FULL_DETAILS_LINK,
  EXTRA_INSURANCE_CONDITIONS_LINK,
} from './constants';

export const InsuranceDescription = (props: {
  tooltip: string;
  description: string;
}): JSX.Element => {
  const { description, tooltip } = props;

  const { t } = useTranslation();
  return (
    <>
      <span>{description}</span>
      <StyledBubble placement="left" text={tooltip}>
        <>
          {' '}
          <StyledQuestionIcon />{' '}
        </>
      </StyledBubble>
      <StyledLink href={EXTRA_INSURANCE_FULL_DETAILS_LINK}>
        {t('checkout.services.fullDetails')}
      </StyledLink>

      <WarningText>
        <Trans
          i18nKey="checkout.services.insuranceWarning"
          components={{
            Link: <StyledLink href={EXTRA_INSURANCE_CONDITIONS_LINK} />,
          }}
        />
      </WarningText>
    </>
  );
};

const WarningText = styled.span`
  margin-top: 5px;
  display: block;
`;

const StyledQuestionIcon = styled(QuestionIcon)`
  height: 12px;
  path {
    fill: var(--grey1);
  }
`;

const StyledBubble = styled(Bubble)`
  display: inline-flex;
`;

const StyledLink = styled(Link)`
  color: var(--black);
`;
